// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import DebitNote from "./DebitNote";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
// Utils
import { DEBIT_NOTE_TABLE_HEADS } from "./DebitNote.utils";
import Filter from "./Filter";

const DebitNotes = () => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [debitNotes, setDebitNotes] = useState({
        entries: [],
        total_count: 0
    });

    const getDebitNotes = async () => {
        spinService.on();
        const response = await get(EntityConstants.DEBIT_NOTES, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}&queryFilters=${filter.queryFilters}`);
        const data = await response.json();
        setDebitNotes(data);
        spinService.off();
    };

    const onClose = () => {
        getDebitNotes();
        setId(undefined);
        setOpen(false);
        setOpenFilter(false);
    };

    useEffect(() => {
        getDebitNotes();
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h6"
                        component="div" sx={{ flexGrow: 1 }}>
                        Debit Notes
                    </Typography>
                    {

                        permissions.has(PermissionConstants.DEBIT_NOTE_CREATE) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => { setOpen(true) }}
                        >
                            New Debit Note
                        </Button>
                    }
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={DEBIT_NOTE_TABLE_HEADS}
                        tableDatas={debitNotes.entries}
                        totalCount={debitNotes.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={true}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.DEBIT_NOTE_VIEW) && open && <GoDrawer
                    minwidth="50%"
                    title="Debit Note"
                    open={open}
                    onClose={() => onClose()}
                >
                    <DebitNote id={id} onClose={() => onClose()} />
                </GoDrawer>
            }
            {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }


        </React.Fragment>
    );
}

export default DebitNotes;